import { Button, Link } from '@trg/tlw-ui-component';
import { useLayoutStore } from '../../../layout';
import { useMenuStore } from '../../stores';

export function SubCategoryAd() {
  const isDesktop = useLayoutStore.use.isDesktop();
  const selectedSubCategory = useMenuStore.use.selectedSubCategory();

  const categoryAd = selectedSubCategory?.categoryAds;

  return (
    <div className="tlw-relative tlw-aspect-[4/3] lg:tlw-rounded-xl lg:tlw-overflow-hidden lg:tlw-aspect-auto">
      <img
        className="tlw-size-full tlw-object-cover"
        src={
          isDesktop
            ? categoryAd?.imageMediasUrl
            : categoryAd?.mobileImageMediasUrl
        }
        alt={categoryAd?.mainHeading}
      />

      {/* 蒙層鏈接 */}
      <Link
        className="tlw-absolute tlw-inset-0 tlw-p-3 tlw-flex tlw-flex-col tlw-justify-end tlw-items-start tlw-gap-1 tlw-bg-black/25 lg:tlw-p-10 lg:tlw-gap-6 lg:tlw-bg-black/20"
        href={categoryAd?.link}
        target={categoryAd?.linkTarget}
        title={categoryAd?.mainHeading}
      >
        <h4 className="tlw-txt-zh-head-4 tlw-text-txt-white lg:tlw-txt-zh-display-1">
          {categoryAd?.mainHeading}
        </h4>

        {categoryAd?.subHeading &&
          (isDesktop ? (
            <Button className="xl:tlw-min-w-40" size="large" dark>
              {categoryAd.subHeading}
            </Button>
          ) : (
            <p className="tlw-txt-zh-body-2 tlw-text-txt-white tlw-underline">
              {categoryAd.subHeading}+
            </p>
          ))}
      </Link>
    </div>
  );
}
